// source: pbtypes/vehicle/motion_manager/frames.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_vehicle_nav_cam_reconstruction_pose_id_pb = require('../../../pbtypes/vehicle/nav_cam_reconstruction/pose_id_pb.js');
goog.object.extend(proto, pbtypes_vehicle_nav_cam_reconstruction_pose_id_pb);
goog.exportSymbol('proto.motion_manager.Frame', null, global);
goog.exportSymbol('proto.motion_manager.Frame.FrameDetailCase', null, global);
goog.exportSymbol('proto.motion_manager.FrameType', null, global);
goog.exportSymbol('proto.motion_manager.FrameType.Enum', null, global);
goog.exportSymbol('proto.motion_manager.FramedScalarPb', null, global);
goog.exportSymbol('proto.motion_manager.FramedVector2Pb', null, global);
goog.exportSymbol('proto.motion_manager.FramedXYZPb', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.motion_manager.FrameType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.motion_manager.FrameType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.motion_manager.FrameType.displayName = 'proto.motion_manager.FrameType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.motion_manager.Frame = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.motion_manager.Frame.oneofGroups_);
};
goog.inherits(proto.motion_manager.Frame, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.motion_manager.Frame.displayName = 'proto.motion_manager.Frame';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.motion_manager.FramedScalarPb = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.motion_manager.FramedScalarPb, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.motion_manager.FramedScalarPb.displayName = 'proto.motion_manager.FramedScalarPb';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.motion_manager.FramedVector2Pb = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.motion_manager.FramedVector2Pb, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.motion_manager.FramedVector2Pb.displayName = 'proto.motion_manager.FramedVector2Pb';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.motion_manager.FramedXYZPb = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.motion_manager.FramedXYZPb, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.motion_manager.FramedXYZPb.displayName = 'proto.motion_manager.FramedXYZPb';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.motion_manager.FrameType.prototype.toObject = function(opt_includeInstance) {
  return proto.motion_manager.FrameType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.motion_manager.FrameType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.motion_manager.FrameType.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.motion_manager.FrameType}
 */
proto.motion_manager.FrameType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.motion_manager.FrameType;
  return proto.motion_manager.FrameType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.motion_manager.FrameType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.motion_manager.FrameType}
 */
proto.motion_manager.FrameType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.motion_manager.FrameType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.motion_manager.FrameType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.motion_manager.FrameType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.motion_manager.FrameType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.motion_manager.FrameType.Enum = {
  INVALID: 0,
  NAV: 1,
  WORLD: 2,
  GPS: 3,
  GLOBAL_GRAPH: 4,
  BARO: 100,
  VEHICLE_CENTRIC_AGL: 101
};


/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.motion_manager.Frame.oneofGroups_ = [[2]];

/**
 * @enum {number}
 */
proto.motion_manager.Frame.FrameDetailCase = {
  FRAME_DETAIL_NOT_SET: 0,
  POSE_ID: 2
};

/**
 * @return {proto.motion_manager.Frame.FrameDetailCase}
 */
proto.motion_manager.Frame.prototype.getFrameDetailCase = function() {
  return /** @type {proto.motion_manager.Frame.FrameDetailCase} */(jspb.Message.computeOneofCase(this, proto.motion_manager.Frame.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.motion_manager.Frame.prototype.toObject = function(opt_includeInstance) {
  return proto.motion_manager.Frame.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.motion_manager.Frame} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.motion_manager.Frame.toObject = function(includeInstance, msg) {
  var f, obj = {
type: jspb.Message.getFieldWithDefault(msg, 1, 0),
poseId: (f = msg.getPoseId()) && pbtypes_vehicle_nav_cam_reconstruction_pose_id_pb.PoseIdPb.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.motion_manager.Frame}
 */
proto.motion_manager.Frame.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.motion_manager.Frame;
  return proto.motion_manager.Frame.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.motion_manager.Frame} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.motion_manager.Frame}
 */
proto.motion_manager.Frame.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.motion_manager.FrameType.Enum} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = new pbtypes_vehicle_nav_cam_reconstruction_pose_id_pb.PoseIdPb;
      reader.readMessage(value,pbtypes_vehicle_nav_cam_reconstruction_pose_id_pb.PoseIdPb.deserializeBinaryFromReader);
      msg.setPoseId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.motion_manager.Frame.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.motion_manager.Frame.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.motion_manager.Frame} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.motion_manager.Frame.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getPoseId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_vehicle_nav_cam_reconstruction_pose_id_pb.PoseIdPb.serializeBinaryToWriter
    );
  }
};


/**
 * optional FrameType.Enum type = 1;
 * @return {!proto.motion_manager.FrameType.Enum}
 */
proto.motion_manager.Frame.prototype.getType = function() {
  return /** @type {!proto.motion_manager.FrameType.Enum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.motion_manager.FrameType.Enum} value
 * @return {!proto.motion_manager.Frame} returns this
 */
proto.motion_manager.Frame.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional nav_cam_reconstruction.PoseIdPb pose_id = 2;
 * @return {?proto.nav_cam_reconstruction.PoseIdPb}
 */
proto.motion_manager.Frame.prototype.getPoseId = function() {
  return /** @type{?proto.nav_cam_reconstruction.PoseIdPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_nav_cam_reconstruction_pose_id_pb.PoseIdPb, 2));
};


/**
 * @param {?proto.nav_cam_reconstruction.PoseIdPb|undefined} value
 * @return {!proto.motion_manager.Frame} returns this
*/
proto.motion_manager.Frame.prototype.setPoseId = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.motion_manager.Frame.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.motion_manager.Frame} returns this
 */
proto.motion_manager.Frame.prototype.clearPoseId = function() {
  return this.setPoseId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.motion_manager.Frame.prototype.hasPoseId = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.motion_manager.FramedScalarPb.prototype.toObject = function(opt_includeInstance) {
  return proto.motion_manager.FramedScalarPb.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.motion_manager.FramedScalarPb} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.motion_manager.FramedScalarPb.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
frame: (f = msg.getFrame()) && proto.motion_manager.Frame.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.motion_manager.FramedScalarPb}
 */
proto.motion_manager.FramedScalarPb.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.motion_manager.FramedScalarPb;
  return proto.motion_manager.FramedScalarPb.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.motion_manager.FramedScalarPb} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.motion_manager.FramedScalarPb}
 */
proto.motion_manager.FramedScalarPb.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    case 2:
      var value = new proto.motion_manager.Frame;
      reader.readMessage(value,proto.motion_manager.Frame.deserializeBinaryFromReader);
      msg.setFrame(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.motion_manager.FramedScalarPb.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.motion_manager.FramedScalarPb.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.motion_manager.FramedScalarPb} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.motion_manager.FramedScalarPb.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getFrame();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.motion_manager.Frame.serializeBinaryToWriter
    );
  }
};


/**
 * optional double value = 1;
 * @return {number}
 */
proto.motion_manager.FramedScalarPb.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.motion_manager.FramedScalarPb} returns this
 */
proto.motion_manager.FramedScalarPb.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional Frame frame = 2;
 * @return {?proto.motion_manager.Frame}
 */
proto.motion_manager.FramedScalarPb.prototype.getFrame = function() {
  return /** @type{?proto.motion_manager.Frame} */ (
    jspb.Message.getWrapperField(this, proto.motion_manager.Frame, 2));
};


/**
 * @param {?proto.motion_manager.Frame|undefined} value
 * @return {!proto.motion_manager.FramedScalarPb} returns this
*/
proto.motion_manager.FramedScalarPb.prototype.setFrame = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.motion_manager.FramedScalarPb} returns this
 */
proto.motion_manager.FramedScalarPb.prototype.clearFrame = function() {
  return this.setFrame(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.motion_manager.FramedScalarPb.prototype.hasFrame = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.motion_manager.FramedVector2Pb.prototype.toObject = function(opt_includeInstance) {
  return proto.motion_manager.FramedVector2Pb.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.motion_manager.FramedVector2Pb} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.motion_manager.FramedVector2Pb.toObject = function(includeInstance, msg) {
  var f, obj = {
x: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
y: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
frame: (f = msg.getFrame()) && proto.motion_manager.Frame.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.motion_manager.FramedVector2Pb}
 */
proto.motion_manager.FramedVector2Pb.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.motion_manager.FramedVector2Pb;
  return proto.motion_manager.FramedVector2Pb.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.motion_manager.FramedVector2Pb} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.motion_manager.FramedVector2Pb}
 */
proto.motion_manager.FramedVector2Pb.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setX(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setY(value);
      break;
    case 3:
      var value = new proto.motion_manager.Frame;
      reader.readMessage(value,proto.motion_manager.Frame.deserializeBinaryFromReader);
      msg.setFrame(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.motion_manager.FramedVector2Pb.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.motion_manager.FramedVector2Pb.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.motion_manager.FramedVector2Pb} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.motion_manager.FramedVector2Pb.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getY();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getFrame();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.motion_manager.Frame.serializeBinaryToWriter
    );
  }
};


/**
 * optional double x = 1;
 * @return {number}
 */
proto.motion_manager.FramedVector2Pb.prototype.getX = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.motion_manager.FramedVector2Pb} returns this
 */
proto.motion_manager.FramedVector2Pb.prototype.setX = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double y = 2;
 * @return {number}
 */
proto.motion_manager.FramedVector2Pb.prototype.getY = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.motion_manager.FramedVector2Pb} returns this
 */
proto.motion_manager.FramedVector2Pb.prototype.setY = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional Frame frame = 3;
 * @return {?proto.motion_manager.Frame}
 */
proto.motion_manager.FramedVector2Pb.prototype.getFrame = function() {
  return /** @type{?proto.motion_manager.Frame} */ (
    jspb.Message.getWrapperField(this, proto.motion_manager.Frame, 3));
};


/**
 * @param {?proto.motion_manager.Frame|undefined} value
 * @return {!proto.motion_manager.FramedVector2Pb} returns this
*/
proto.motion_manager.FramedVector2Pb.prototype.setFrame = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.motion_manager.FramedVector2Pb} returns this
 */
proto.motion_manager.FramedVector2Pb.prototype.clearFrame = function() {
  return this.setFrame(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.motion_manager.FramedVector2Pb.prototype.hasFrame = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.motion_manager.FramedXYZPb.prototype.toObject = function(opt_includeInstance) {
  return proto.motion_manager.FramedXYZPb.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.motion_manager.FramedXYZPb} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.motion_manager.FramedXYZPb.toObject = function(includeInstance, msg) {
  var f, obj = {
xy: (f = msg.getXy()) && proto.motion_manager.FramedVector2Pb.toObject(includeInstance, f),
z: (f = msg.getZ()) && proto.motion_manager.FramedScalarPb.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.motion_manager.FramedXYZPb}
 */
proto.motion_manager.FramedXYZPb.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.motion_manager.FramedXYZPb;
  return proto.motion_manager.FramedXYZPb.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.motion_manager.FramedXYZPb} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.motion_manager.FramedXYZPb}
 */
proto.motion_manager.FramedXYZPb.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.motion_manager.FramedVector2Pb;
      reader.readMessage(value,proto.motion_manager.FramedVector2Pb.deserializeBinaryFromReader);
      msg.setXy(value);
      break;
    case 2:
      var value = new proto.motion_manager.FramedScalarPb;
      reader.readMessage(value,proto.motion_manager.FramedScalarPb.deserializeBinaryFromReader);
      msg.setZ(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.motion_manager.FramedXYZPb.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.motion_manager.FramedXYZPb.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.motion_manager.FramedXYZPb} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.motion_manager.FramedXYZPb.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getXy();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.motion_manager.FramedVector2Pb.serializeBinaryToWriter
    );
  }
  f = message.getZ();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.motion_manager.FramedScalarPb.serializeBinaryToWriter
    );
  }
};


/**
 * optional FramedVector2Pb xy = 1;
 * @return {?proto.motion_manager.FramedVector2Pb}
 */
proto.motion_manager.FramedXYZPb.prototype.getXy = function() {
  return /** @type{?proto.motion_manager.FramedVector2Pb} */ (
    jspb.Message.getWrapperField(this, proto.motion_manager.FramedVector2Pb, 1));
};


/**
 * @param {?proto.motion_manager.FramedVector2Pb|undefined} value
 * @return {!proto.motion_manager.FramedXYZPb} returns this
*/
proto.motion_manager.FramedXYZPb.prototype.setXy = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.motion_manager.FramedXYZPb} returns this
 */
proto.motion_manager.FramedXYZPb.prototype.clearXy = function() {
  return this.setXy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.motion_manager.FramedXYZPb.prototype.hasXy = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional FramedScalarPb z = 2;
 * @return {?proto.motion_manager.FramedScalarPb}
 */
proto.motion_manager.FramedXYZPb.prototype.getZ = function() {
  return /** @type{?proto.motion_manager.FramedScalarPb} */ (
    jspb.Message.getWrapperField(this, proto.motion_manager.FramedScalarPb, 2));
};


/**
 * @param {?proto.motion_manager.FramedScalarPb|undefined} value
 * @return {!proto.motion_manager.FramedXYZPb} returns this
*/
proto.motion_manager.FramedXYZPb.prototype.setZ = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.motion_manager.FramedXYZPb} returns this
 */
proto.motion_manager.FramedXYZPb.prototype.clearZ = function() {
  return this.setZ(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.motion_manager.FramedXYZPb.prototype.hasZ = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.motion_manager);
